import React from 'react'
import { Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts'
import { roundToDecimalPlace } from 'utils/data'
import {
  ChartHeader,
  ChartHeaderTitle,
  ChartTitle,
  RechartsWrapper,
  TooltipContainer,
} from '../../../../pages/ExplorePools/Metrics/styled'

const formatDate = (timestamp: number) => {
  const date = new Date(timestamp * 1000)
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date)
}

interface HBHYPEGraphProps {
  totalSupply7D: Array<{
    timestamp: number
    value: number
  }>
  hypePrice: number
}

const HBHYPEGraph: React.FC<HBHYPEGraphProps> = ({ totalSupply7D, hypePrice }) => {
  const chartData = [...totalSupply7D]
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((item) => ({
      name: item.timestamp,
      value: item.value,
    }))

  const lastValue = [...totalSupply7D].sort((a, b) => b.timestamp - a.timestamp)[0]?.value

  if (chartData.length === 0) {
    return null
  }

  return (
    <RechartsWrapper style={{ background: 'none', padding: '16px 0', marginTop: '16px' }}>
      <ChartHeader>
        <ChartHeaderTitle>
          <ChartTitle style={{ color: 'white', fontWeight: 800 }}>Total Supply</ChartTitle>
        </ChartHeaderTitle>
        <ChartTitle>{lastValue ? `${roundToDecimalPlace(`${lastValue * hypePrice}`, '0')}$` : ''}</ChartTitle>
      </ChartHeader>
      <ResponsiveContainer width="100%" height={185}>
        <AreaChart data={chartData}>
          <defs>
            <linearGradient id="colorVolume" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#4AFB39" stopOpacity={0.7} />
              <stop offset="100%" stopColor="#4AFB39" stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area type="monotone" dataKey="value" stroke="#4AFB39" fill="url(#colorVolume)" />
          <Tooltip
            content={({ payload }) => {
              if (payload && payload.length > 0) {
                const data = payload[0].payload
                return (
                  <TooltipContainer>
                    <span className="tooltip__heading">{formatDate(data.name)}</span>
                    <div className="tooltip__volume">
                      <span className="tooltip__volume-title">Total Supply</span>
                      <span className="tooltip__volume-value">
                        {roundToDecimalPlace(`${data.value * hypePrice}`, '0')}$
                      </span>
                    </div>
                  </TooltipContainer>
                )
              }
              return null
            }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </RechartsWrapper>
  )
}

export default HBHYPEGraph
